import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { MarketplaceService } from '@fgb/core';

@Component({
  selector: 'fgb-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.scss']
})
export class EventsPageComponent implements OnInit {
  screenType = ScreenType;
  constructor(private marketplaceService: MarketplaceService) {}

  ngOnInit() {
    
    this.marketplaceService.fetchMarketplaceItems().toPromise();
  }
}
